export default __webpack_public_path__ + "static/media/Buy-crypto.bcb17692.png";